import Home from "./Home";
import { useOutletContext } from "react-router-dom";
function RouteMap(props) {
  const { profile, theme } = useOutletContext();
  const composite = {
    home: <Home theme={theme} profile={profile} />,
  };
  return <>{composite[props.component]}</>;
}
export default RouteMap;
